import { Component, inject } from '@angular/core';
import { MatButtonModule, MatIconButton } from '@angular/material/button';
import { MatCardModule } from '@angular/material/card';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatDividerModule } from '@angular/material/divider';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { MatSlideToggle } from '@angular/material/slide-toggle';
import { Router } from '@angular/router';
import { ThemeService } from '../../services/theme.service';
import { AuthService } from '../../services/auth.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FormGroup, FormControl } from '@angular/forms';
import { Validators } from '@angular/forms';
import { AutofocusDirective } from '../../helpers/autofocus.directive';
import { UtilService } from '../../services/util.service';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ResetComponent } from "../reset/reset.component";
import { DlgAlertComponent } from '../dlg-alert/dlg-alert.component';
import { HttpErrorResponse } from '@angular/common/http';
import { PasswordExpirationService } from '../../services/password-expiration.service';

@Component({
  selector: 'app-login',
  imports: [
    MatCardModule,
    AutofocusDirective,
    MatButtonModule,
    MatIconButton,
    MatIconModule,
    MatDialogModule,
    MatDividerModule,
    MatFormFieldModule,
    MatInputModule,
    MatSelectModule,
    FormsModule,
    ReactiveFormsModule,
    MatProgressSpinnerModule
  ],
  templateUrl: './login.component.html',
  styleUrl: './login.component.scss'
})
export class LoginComponent {
  /*Manejo de thema*/
  themeService: ThemeService = inject(ThemeService);
  toogleTheme = () => this.themeService.updateTheme();
  readonly dialog = inject(MatDialog);
  msgErrorLogin = "Usuario y/o contrase\xF1a incorrectos";
  tmpUser = localStorage.getItem('username') || ""
  loginForm = new FormGroup({
    username: new FormControl(localStorage.getItem("username") || "", {
      validators: [Validators.required]
    }),
    password: new FormControl("", {
      validators: [Validators.required]
    })
  })

  loginFailed = false
  fetchingLogin = false

  readonly institutionNameConfigID = 21
  institutionName?: string

  readonly systemNameConfigID = 608
  systemName?: string

  readonly logoConfigID = 501
  logoPath?: SafeResourceUrl

  constructor(
    private router: Router,
    private authService: AuthService,
    private passwordExpirationService: PasswordExpirationService,
    utilService: UtilService,
    _sanitizer: DomSanitizer
  ) {
    utilService.getConfigurationParameter(this.institutionNameConfigID).subscribe({
      next: (response) => {
        this.institutionName = response.texto
      }
    })
    utilService.getConfigurationParameter(this.systemNameConfigID).subscribe({
      next: (response) => {
        this.systemName = response.texto
        localStorage.setItem("system-name", this.systemName ? this.systemName : "Gestión documental")
      }
    })
    utilService.getConfigurationParameter(this.logoConfigID).subscribe({
      next: (response) => {
        this.logoPath = _sanitizer.bypassSecurityTrustResourceUrl(response.texto);
      }
    })
  }

  hide = true;
  clickEvent(event: MouseEvent) {
    this.hide = !this.hide;
    event.stopPropagation();
  }

  onLogin() {
    this.loginFailed = false
    this.fetchingLogin = true

    const username = this.loginForm.value.username!
    const password = this.loginForm.value.password!

    this.authService.login(username, password).subscribe({
      next: () => {
        localStorage.setItem("username", username)
        this.checkPasswordExpiration()
        this.router.navigateByUrl("/")
      },
      error: (e: HttpErrorResponse) => {
        if (e.error?.msg) {
          this.msgErrorLogin = e.error.msg;
        } else {
          this.msgErrorLogin = "Upsss!! esto no deber\xEDa estar pasando, por favor contacte al administrador del sistema";
        }
        this.loginFailed = true
        this.fetchingLogin = false
      },
    })
  }

  resetPassword() {
    const dialogRef = this.dialog.open(ResetComponent, { maxWidth: "40vw" });

    dialogRef.afterClosed().subscribe((result: any) => {
      if (!result) return;
      if (result == 1) {
        this.dialog.open(DlgAlertComponent, {
          data: {
            title: 'Datos correctos',
            message: 'Hemos enviado a su correo las instrucciones para resetear su clave'
          }
        });
      } else {
        this.dialog.open(DlgAlertComponent, {
          data: {
            title: 'Error',
            message: 'Tuvimos inconvenientes al validar sus datos, por favor verifique los datos e int\xe9ntelo nuevamente'
          }
        });
      }
    });
  }

  checkPasswordExpiration() {
    this.passwordExpirationService.checkPasswordExpiration();
  }
}
